module.exports = __webpack_public_path__ + "static/img/file_word.5c5c0b2d.png";